var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEbcSlipAndFall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14161_103896)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_14161_103896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5 11H20.5C16.0817 11 12.5 14.5817 12.5 19V59C12.5 63.4183 16.0817 67 20.5 67H59.5C63.9183 67 67.5 63.4183 67.5 59V19C67.5 14.5817 63.9183 11 59.5 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5 12.5H20.5C16.9101 12.5 14 15.4101 14 19V59C14 62.5899 16.9101 65.5 20.5 65.5H59.5C63.0899 65.5 66 62.5899 66 59V19C66 15.4101 63.0899 12.5 59.5 12.5Z",
    stroke: "#FF8027",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.025 48.546C36.8963 48.7588 36.6884 48.9117 36.447 48.9713C36.2055 49.0308 35.9504 48.992 35.7375 48.8634L25.4446 42.6476C25.2326 42.5185 25.0805 42.3107 25.0215 42.0697C24.9625 41.8287 25.0015 41.5741 25.1298 41.3618C25.2582 41.1494 25.4655 40.9966 25.7063 40.9368C25.9471 40.877 26.2018 40.9151 26.4146 41.0428L36.7076 47.2586C36.9204 47.3872 37.0734 47.5952 37.1329 47.8366C37.1924 48.078 37.1536 48.3332 37.025 48.546ZM46.5572 39.034C47.0493 39.034 47.5304 38.8881 47.9396 38.6147C48.3487 38.3413 48.6676 37.9527 48.8559 37.498C49.0443 37.0434 49.0935 36.5431 48.9975 36.0605C48.9015 35.5778 48.6645 35.1345 48.3165 34.7865C47.9686 34.4386 47.5252 34.2016 47.0426 34.1056C46.5599 34.0096 46.0596 34.0589 45.605 34.2472C45.1504 34.4356 44.7618 34.7545 44.4884 35.1637C44.215 35.5729 44.0691 36.0539 44.0691 36.546C44.0692 37.2059 44.3313 37.8387 44.7979 38.3053C45.2645 38.7719 45.8974 39.034 46.5572 39.034ZM54.4175 32.0258C54.1864 31.9349 53.9288 31.9385 53.7004 32.036C53.472 32.1335 53.2911 32.3169 53.1968 32.5467L50.5113 39.2378L49.7032 40.0292H44.081L42.0201 36.1876V29.9425C42.0206 29.8191 41.9968 29.6968 41.9499 29.5827C41.903 29.4685 41.8341 29.3648 41.747 29.2773C41.66 29.1899 41.5565 29.1205 41.4425 29.0732C41.3286 29.0258 41.2064 29.0015 41.083 29.0015C40.9596 29.0015 40.8374 29.0258 40.7235 29.0732C40.6095 29.1205 40.506 29.1899 40.419 29.2773C40.3319 29.3648 40.263 29.4685 40.2161 29.5827C40.1692 29.6968 40.1454 29.8191 40.1459 29.9425V36.4236C40.1457 36.5782 40.1841 36.7303 40.2574 36.8664L42.8133 41.6337L39.9982 44.9066L37.4539 39.0506C37.4056 38.9411 37.3371 38.8417 37.2521 38.7576L30.6977 32.2976C30.5204 32.1249 30.2819 32.0293 30.0343 32.0318C29.7867 32.0342 29.5502 32.1345 29.3763 32.3108C29.2024 32.487 29.1053 32.7249 29.1062 32.9725C29.1071 33.2201 29.2059 33.4573 29.381 33.6323L35.806 39.9653L39.4869 48.4353C39.5599 48.6027 39.6802 48.7451 39.833 48.8452C39.9858 48.9452 40.1644 48.9985 40.3471 48.9984H42.8422C43.0873 48.9984 43.3226 48.9026 43.4981 48.7315L51.9633 40.4405C52.0561 40.3494 52.1292 40.2403 52.1781 40.1198L54.9385 33.2465C55.0309 33.0155 55.0279 32.7573 54.9303 32.5285C54.8326 32.2997 54.6481 32.119 54.4175 32.0258Z",
    fill: "#FF8027"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14161_103896",
    x: 0.5,
    y: 0,
    width: 79,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14161_103896"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14161_103896",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_14161_103896",
    x: 0.5,
    y: 0,
    width: 79,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14161_103896"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14161_103896",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_14161_103896"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbcSlipAndFall);
export default __webpack_public_path__ + "static/media/EBC-slip-and-fall.2e2308e4246707c8412a624c9b852dfd.svg";
export { ForwardRef as ReactComponent };